import { render } from "./EmailVerified.vue?vue&type=template&id=11e4b936&ts=true"
import script from "./EmailVerified.vue?vue&type=script&lang=ts"
export * from "./EmailVerified.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__